module.exports = __webpack_public_path__ + "static/media/submit-success.6da01980.png";